import { render } from "./SurveryPlusStructureStep.vue?vue&type=template&id=1a06dbbc&ts=true"
import script from "./SurveryPlusStructureStep.vue?vue&type=script&lang=ts"
export * from "./SurveryPlusStructureStep.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__